module.exports = __webpack_public_path__ + "img/my-resentation.876bc0a9.png";